<template>
    <div class="flex items-center group gap-6">
        <div
            v-if="card && showImage"
            class="hidden at1024:block w-20 rounded-md"
            :class="{
                'bg-gray-tier-5': !productCardImage(card),
            }"
        >
            <img v-if="productCardImage(card)" class="mx-auto max-w-full object-contain min-w-20 max-h-20" :src="productCardImage(card)" alt="">
            <BaseSvg v-else name="icon-product-empty" class="opacity-20 mx-auto max-w-full min-w-20 max-h-20 object-contain p-5 rounded-md shrink-0"/>
        </div>
        <div>
            <div v-if="card?.filter_manufacturer && showManufacturer" class="type-secondary text-sm mb-1">{{ card.filter_manufacturer }}</div>
            <div class="flex items-center group">
                <span v-if="disabled" class="font-medium text-red">{{ linkText }}</span>
                <Link
                    v-if="routeParams"
                    :href="route(routeName ? routeName : route().current(), routeParams)"
                    class="hover:underline hover:underline-offset-6 hover:decoration-solid font-semibold"
                    :class="linkColor"
                >
                    {{ linkText }}
                </Link>
                <span v-else class="text-lg" :class="linkColor">
                    {{ linkText }}
                </span>
                <button
                    v-if="event.enabled && !disabled"
                    :disabled="disabled"
                    @click="
                        () => {
                            eventBus.emit(event.name, {
                                event: $event,
                                data: event.data,
                            });
                        }
                    "
                    class="invisible group-hover:visible opacity-50 hover:opacity-100"
                >
                    <BaseSvg :name="icon" />
                </button>
            </div>

            <div v-if="linkDescription" class="flex relative items-center mt-1">
                <span class="type-secondary text-sm">{{ linkDescription }}</span>
            </div>

            <span
                v-if="line?.prc_origin === 'OVRD' && !quote?.source_code?.startsWith('IMP') && line.price > 0"
                class="block w-fit mt-1 text-xs px-1.5 text-white font-medium bg-blue rounded-sm"
            >
                {{ $t('Special Pricing Applied') }}
            </span>

            <span v-if="line.notes?.length" class="mt-1 type-tertiary leading-tight text-sm block">
                <template v-for="(note, index) in line.notes">
                    {{ note.text }}
                    <template v-if="index !== line.notes.length - 1">
                        &nbsp;|&nbsp;
                    </template>
                </template>
            </span>

            <span
                v-if="line?.item_id?.startsWith('@')"
                class="block w-fit mt-1 text-xs px-1.5 text-white font-medium bg-orange rounded-sm"
            >
                {{ $t('This item cannot be purchased online, please contact us.') }}
            </span>

            <button
                @click.stop.prevent="downloadCutSheet"
                v-if="line.is_web"
                class="font-medium mt-1 type-tertiary text-xs underline underline-offset-4 hover:type-primary"
            >
                Cut Sheet
            </button>
        </div>
    </div>

</template>
<script setup>
import { Link } from "@inertiajs/vue3";
import { BaseSvg } from "@/Components";
import { eventBus } from "@/Composables";

const props = defineProps({
    linkColor: {
        type: String,
        default: "type-primary font-medium", // ticket said to use "font-bold (font-weight: 600)" but "font-medium" is 600
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    routeName: {
        type: String,
        default: false,
    },
    routeParams: {
        type: Array,
        default: () => [],
    },
    linkText: {
        type: String,
        default: "—",
    },
    linkDescription: {
        type: String,
        default: false,
    },
    icon: {
        type: String,
        default: "icon-preview",
    },
    line: {
        type: Object,
        required: true,
    },
    quote: {
        type: Object,
        required: true,
    },
    event: {
        type: [Object],
        default: () => {
            return {
                name: "preview",
                data: {},
                enabled: false,
            };
        },
    },
    showImage: {
        type: Boolean,
        default: false,
    },
    card: {
        type: Object,
        required: true,
    },
    showManufacturer: {
        type: Boolean,
        required: false,
        default: false,
    },
    showDescription: {
        type: Boolean,
        required: false,
        default: false,
    },
});

const downloadCutSheet = () => {
    window.location = route("web.catalog.products.cut-sheet.download", {
        slug: props.line.slug,
    });
};

</script>
